















































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import config from "@/services/api-config";
import store from "@/store";
import * as moment from "moment";
import "../styles/global.scss";
import WidgetBox from "../components/widget-box/widget-box.vue";
import GeneralService from "@/services/general-service";
import AuthService from "../services/auth-service";

@Component({
  components: {
    "widget-box": WidgetBox,
  },
})
export default class CustomerList extends Vue {
  private customerData: any = [];
  private userRoles = JSON.parse(localStorage[config.userRole]);
  private selectedCustomer = 0;
  plantID = 0;
  inverterID = 0;
  statusID = 0;
  private isCustomer = false;
  private searchUser = "";
  private service = new GeneralService();
  private plantsData: any = [];
  private plantsList: any = [];
  private isAdmin = true;
  private loaded = false;
  alarmList: any = [];
  private lazyLoadingCount = 0;
  private pageIndex = 0;
  private searchPlantFilter = "";
  private plantInverterList: any = [];
  inverterList: any = [];
  private auth = new AuthService();
  private json_field = {
    Name: "plantname",
    Location: "plantlocation",
    Type: "name",
    "Power Capacity": "plantmaximumpower",
    "Last Producing": "powernow",
    "Energy Today": "energy_today",
    "Specific Energy Today": "specific_energy_today",
    Status: "plant_current_status",
  };
  private fields = [
    {
      key: "plantname",
      sortable: false,
      label: "Name",
    },
    {
      key: "plantlocation",
      sortable: true,
      tdClass: "tdWidth100",
      label: "Location",
    },
    {
      key: "name",
      label: "Type",
      sortable: true,
    },
    {
      key: "plantmaximumpower",
      label: "Power Capacity",
      sortable: true,
      formatter: function (value, key, item) {
        return value + " kW";
      },
    },
    {
      key: "powernow",
      label: "Last Producing",
      sortable: true,
      formatter: function (value, key, item) {
        return value + " W";
      },
    },
    {
      key: "energy_today",
      label: "Energy Today",
      sortable: true,
      formatter: function (value, key, item) {
        return value + " kWh";
      },
    },
    {
      key: "specific_energy_today",
      label: "Specific Energy Today",
      sortable: true,
      formatter: function (value, key, item) {
        return value + " kWh/kWp";
      },
    },
    {
      key: "net_metered",
      label: "Net Metering",
      formatter: function (value, key, item) {
        if (value) return "Yes";
        else return "No";
      },
    },
    {
      key: "plant_current_status",
      label: "Status",
      sortable: true,
      tdClass: "tdWidth200",
    },
  ];

  rowSelected(items: any, index: any) {
    this.showDashboard(items.serialID);
  }

  formatNumber(num) {
    if (num || num == 0) {
      return num
        .toFixed(0)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }

    return null;
  }

  reloadPage() {
    localStorage[config.currentCustomer] = null;
    localStorage[config.currentCustomerBackup] = null;
    window.location.reload();
  }

  showInverterOffline() {
    this.$bvModal.show("inverter-data");
  }

  lazyLoad(index: number) {
    if (this.lazyLoadingCount > 0) {
      this.service.getPlantsListAdmin(index * 10, 10).then((response) => {
        for (let plant of response.data.response_list) {
          this.plantsList.push(plant);
        }

        for (let i = 0; i < this.plantsList.length; i++) {
          this.plantsList[i].index = i;
        }

        this.lazyLoadingCount -= 10;
        let index_ = index + 1;
        this.lazyLoad(index_);
      });
    } else {
      return;
    }
  }

  showPlant(id: number) {
    if (id == -1) {
      this.service.getPlantsListAdmin(0, 10).then((response) => {
        this.selectedCustomer = id;
        localStorage[config.currentCustomer] = id;
        this.plantsList = response.data.response_list;
        for (let i = 0; i < this.plantsList.length; i++) {
          this.plantsList[i].index = i;
        }
        this.isCustomer = true;
        this.loaded = true;
        this.lazyLoadingCount = response.data.total_records;
        this.lazyLoad(1);
      });
    } else {
      this.selectedCustomer = id - 1;
      localStorage[config.currentCustomer] = id;
      this.service.getPlantsList(id).then((response) => {
        this.plantsList = response.data;
        for (let i = 0; i < this.plantsList.length; i++) {
          this.plantsList[i].index = i;
        }
        this.isCustomer = true;
        this.loaded = true;
      });
    }
  }
  formatDate(value) {
    return moment.unix(value).format("DD-MM-YYYY");
  }

  showDashboard(id: number) {
    localStorage[config.currentPlant] = JSON.stringify(id);
    if (
      localStorage[config.currentCustomer] == "null" ||
      !localStorage[config.currentCustomer]
    )
      localStorage[config.currentCustomer] =
        localStorage[config.currentCustomerBackup];
    this.$router.push("/dashboard");
  }

  showDirectDashboard(id: number) {
    localStorage[config.currentPlant] = JSON.stringify(id);
    this.$router.push("/dashboard");
  }

  searchName() {
    for (let i = 0; i < this.customerData.length; i++) {
      const customerName = this.customerData[i].customername.toLowerCase();
      const customerAddress = '';
      const customerPhoneNumer = '';

      if (customerName != 'all customers'){
        const customerAddress =
          this.customerData[i].customeraddress.toLowerCase();
        const customerPhoneNumer =
          this.customerData[i].customerphonenumber.toLowerCase();
      }
      
      const searchUser = this.searchUser.toLowerCase();

      const els = document.getElementsByClassName(
        this.customerData[i].customername
      );
      if (
        customerName.includes(searchUser) ||
        customerAddress.includes(searchUser) ||
        customerPhoneNumer.includes(searchUser)
      ) {
        for (let el of els) {
          (el as any).style.display = "block";
        }
      } else {
        for (let el of els) {
          (el as any).style.display = "none";
        }
      }
    }
  }

  mounted() {
    this.GetPlantsAndInvertersList();
    this.loadAlarmList();
    if (!this.customerData || this.customerData === undefined) {
      this.$router.push("/login");
    }

    this.service.getCustomerList().then((response) => {
      this.customerData = response.data;

      if (
        !(this.userRoles.includes("admin") || this.userRoles.includes("tech"))
      ) {
        this.isAdmin = false;
      } else {
        this.customerData.unshift({
          customername: "All Customers",
          serialid: -1,
        });
      }

      if (
        !(
          this.userRoles.includes("admin") ||
          this.userRoles.includes("tech") ||
          this.customerData.length > 1
        )
      ) {
        this.selectedCustomer = 0;
        this.isCustomer = true;
        this.showPlant(this.customerData[0].serialid);
      } else {
        this.service.getExecutiveDashboard().then((response) => {
          this.plantsData = response.data[0];
          if (
            localStorage[config.currentCustomer] !== "null" &&
            localStorage[config.currentCustomer]
          ) {
            this.showPlant(localStorage[config.currentCustomer]);
            localStorage[config.currentCustomerBackup] =
              localStorage[config.currentCustomer];
            localStorage[config.currentCustomer] = null;
          } else {
            this.loaded = true;
          }
        });
      }
    });

    setInterval(() => {
      if (this.userRoles.includes("admin") || this.userRoles.includes("tech")) {
        this.service.getExecutiveDashboard().then((response) => {
          this.plantsData = response.data[0];
        });
      }
    }, 300000);
  }

  GetPlantsAndInvertersList() {
    this.service.GetPlantsAndInvertersList().then((response) => {
      if (response.data) {
        this.plantInverterList = response.data.response;
      }
    });
  }

  loadInverters() {
    let a = this.plantInverterList.filter(
      (event) => event.SerialID == this.plantID
    );
    if (a.length > 0) {
      this.inverterList = a[0].plantinverters;
    }
  }

  loadAlarmList() {
    this.service
      .Getallalarmsclient(this.plantID, this.inverterID, this.statusID)
      .then((response) => {
        if (response.data.total_records > 0) {
          this.alarmList = response.data.alarms_list;
        } else {
          this.alarmList = [];
        }
      });
  }

  markAlarmResolved(id) {
    this.$confirm("Are you sure to change the status?").then(() => {
      this.service.updateAlarmStatus(id).then((response) => {
        this.loadAlarmList();
      });
    });
  }
}
